/**
 * @ngdoc component
 * @name commentHistory
 * @module flowingly.components
 * @description This is a component for displaying the comment history
 *
 * Input attributes
 * comment - the comment object
 * isFirstComment - if it's first comment
 * isLastComment - if it's last comment
 * isMobile - is that mobile view?
 *
 * @usage
 * ```
 * <comment-history comment="comment" is-first-comment="$index === 0" is-last-comment="$index === $ctrl.commentList.length - 1" is-mobile="$ctrl.isMobile"></comment-history>
 * ```
 */

import * as angular from 'angular';
import { CommentType } from '../../interfaces/comment.interface';

export class CommentHistoryComponent implements angular.IComponentOptions {
  public bindings: any;
  public templateUrl: string;
  public controller: any;

  constructor() {
    this.bindings = {
      comment: '<',
      isFirstComment: '<',
      isLastComment: '<',
      isMobile: '<'
    };

    this.templateUrl = 'comment-history.tmpl.html';
    this.controller = CommentHistoryController;
  }
}

class CommentHistoryController implements angular.IController {
  public static $inject = [];
  public comment: any;

  public isUserComment: boolean;
  public isStepTaskCreated: boolean;
  public isStepTaskDone: boolean;
  public isStepTaskApproved: boolean;
  public isStepTaskRejected: boolean;

  $onInit(): void {
    const type = this.comment?.commentType;

    this.isUserComment = type === CommentType.UserComment;
    this.isStepTaskCreated = type === CommentType.StepTaskCreated;
    this.isStepTaskDone = type === CommentType.StepTaskDone;
    this.isStepTaskApproved = type === CommentType.StepTaskApproved;
    this.isStepTaskRejected = type === CommentType.StepTaskRejected;
  }
}

angular
  .module('flowingly.components')
  .component('commentHistory', new CommentHistoryComponent());
